<template>
  <v-card flat
          class="results"
          dark>
    <v-subheader class="results-title title black white--text">
      {{translations.roundResultsTitle}}
    </v-subheader>
    <div class="results-items">
      <v-expansion-panel>
        <v-expansion-panel-content hide-actions
                                   class="results-item"
                                   :key="item.id"
                                   v-for="item in items">
          <template v-slot:header>
            <v-layout row
                      wrap>
              <v-flex xs6
                      class="text-xs-left">
                <span>{{translations.roundTitle}} </span>
                <span>{{item.displayId}}</span>
              </v-flex>
              <v-flex xs6
                      class="text-xs-right">
                <span>{{formatRoundDate(item.createdAt)}}</span>
              </v-flex>
            </v-layout>
          </template>
          <v-card flat>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-layout row
                        wrap>
                <v-flex xs5
                        class="text-xs-center">
                  <div class="pa-3">
                    <div>{{translations.winningNumberTitle}}</div>
                    <v-card :color="itemResultColor(item)"
                            width="72"
                            height="72"
                            class="mt-3 mx-auto display-1">
                      <div class="pt-3 white--text">
                        {{item.result}}
                      </div>
                    </v-card>
                  </div>
                </v-flex>
                <v-divider vertical
                           xs1>
                </v-divider>
                <v-flex xs6
                        class="text-xs-left">
                  <div class="pa-3">
                    <div>{{translations.winningBetsTitle}}</div>
                    <div class="mt-3 caption">
                      <div :key="bet.name"
                           v-for="bet in itemWinningBets(item)">
                        {{bet.title}}
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-card>
</template>

<script>
import { filter, findIndex, merge } from 'lodash';
import { DateTime } from 'luxon';
import { mapGetters } from 'vuex';

export default {
  name: 'Results',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'config',
      'results',
      'translations',
    ]),
    items() {
      return this.results.rounds;
    },
  },
  methods: {
    formatRoundDate(value) {
      return DateTime.fromISO(value, {
        setZone: true,
      }).toFormat('dd.MM.yyyy HH:mm');
    },
    itemResultColor(item) {
      const isBlack = findIndex(item.winningBets, bet => bet.name === 'black') > -1;
      const isRed = findIndex(item.winningBets, bet => bet.name === 'red') > -1;

      if (!isBlack && !isRed) return 'green';
      return isBlack ? 'black' : 'red';
    },
    itemWinningBets(item) {
      return filter(item.winningBets, (bet) => {
        const isShown = ['straight', 'snake'].indexOf(bet.name) < 0;
        return isShown;
      });
    },
  },
  beforeMount() {
    const resultsPayload = merge({
      wheel: this.config.wheel,
      locale: this.config.locale,
      timezoneOffset: this.config.timezoneOffset,
      pageSize: 720,
    }, this.$router.currentRoute.query);

    this.$store.dispatch('loadResults', resultsPayload);
  },
};
</script>
